var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "min-width": "20px", "min-height": "20px" },
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
    },
    [
      _c("path", { attrs: { d: "M0 0h24v24H0V0z", fill: "none" } }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z",
          fill: "teal",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }